import { API_BASE_URL } from "../config";
import React, { useState, useEffect } from "react";
import axios from "axios";

const Holdings = () => {
  const [allHoldings, setAllHoldings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/client/allHoldings`)
      .then(res => {
        const holdingsData = Array.isArray(res.data) ? res.data : (res.data?.holdings || []);
        setAllHoldings(holdingsData);
      })
      .catch(err => {
        console.error("Error fetching holdings:", err);
        setAllHoldings([]);
      })
      .finally(() => setLoading(false));
  }, []);

  const safeHoldings = Array.isArray(allHoldings) ? allHoldings : [];
  const totalInvestment = safeHoldings.reduce((sum, h) => sum + ((h.avg || 0) * (h.qty || 0)), 0);
  const currentValue = safeHoldings.reduce((sum, h) => sum + ((h.price || 0) * (h.qty || 0)), 0);
  const totalPnL = currentValue - totalInvestment;
  const pnlPercent = totalInvestment > 0 ? (totalPnL / totalInvestment) * 100 : 0;

  return (
    <>
      <h3 className="title">Long-term Equity Holdings ({allHoldings.length})</h3>

      {loading ? (
        <p>Loading holdings...</p>
      ) : allHoldings.length === 0 ? (
        <div style={{ padding: "40px", textAlign: "center", backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #eee" }}>
          <p style={{ color: "#666", fontSize: "15px", fontWeight: 500, margin: 0 }}>You do not have any equity holdings yet.</p>
          <p style={{ fontSize: "13px", color: "#999", marginTop: "6px" }}>
            T-day intraday and derivative trades appear in <strong>Positions</strong>. Delivery holdings will show here after settlement.
          </p>
        </div>
      ) : (
        <div className="order-table">
          <table>
            <thead>
              <tr>
                <th>Instrument</th>
                <th>Qty.</th>
                <th>Avg. cost</th>
                <th>LTP</th>
                <th>Cur. val</th>
                <th>P&L</th>
                <th>Net chg.</th>
                <th>Day chg.</th>
              </tr>
            </thead>
            <tbody>
              {allHoldings.map((stock, index) => {
                const currVal = stock.price * stock.qty;
                const pnl = currVal - (stock.avg * stock.qty);
                const isProfit = pnl >= 0;
                const profClass = isProfit ? "profit" : "loss";
                return (
                  <tr key={stock._id || index}>
                    <td><strong>{stock.name}</strong></td>
                    <td>{stock.qty}</td>
                    <td>₹{stock.avg ? stock.avg.toFixed(2) : "0.00"}</td>
                    <td>₹{stock.price ? stock.price.toFixed(2) : "0.00"}</td>
                    <td>₹{currVal.toFixed(2)}</td>
                    <td className={profClass}>₹{pnl.toFixed(2)}</td>
                    <td className={profClass}>{stock.net || (isProfit ? "+0.00%" : "-0.00%")}</td>
                    <td>{stock.day || "0.00%"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {allHoldings.length > 0 && (
        <div className="row" style={{ marginTop: "20px" }}>
          <div className="col">
            <h5>₹{totalInvestment.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h5>
            <p>Total investment</p>
          </div>
          <div className="col">
            <h5>₹{currentValue.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h5>
            <p>Current value</p>
          </div>
          <div className="col">
            <h5 style={{ color: totalPnL >= 0 ? "#4caf50" : "#ef5350" }}>
              ₹{totalPnL.toFixed(2)} ({pnlPercent >= 0 ? "+" : ""}{pnlPercent.toFixed(2)}%)
            </h5>
            <p>P&L</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Holdings;
